module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG1d06d74ac44fc08855c08cfb9b2629d0.1d06d74a.png";